import { render } from "./OppDetailsJobsTab.vue?vue&type=template&id=639a4cb0"
import script from "./OppDetailsJobsTab.vue?vue&type=script&lang=js"
export * from "./OppDetailsJobsTab.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__